var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{model:{value:(_vm.getModalForgotPassword),callback:function ($$v) {_vm.getModalForgotPassword=$$v},expression:"getModalForgotPassword"}})
}
var staticRenderFns = []

export { render, staticRenderFns }